<template>
  <v-container>
   <div class="mt-10">
    <v-card class="premium-feature-card">
      <v-card-title class="p-0">
        <img :src="headerImage" />
      </v-card-title>
      <v-card-text class="pl-5 pt-4 pb-0">
        <h3 class="black--text">{{$t('PremiumFeaturesDialog.Title')}}</h3>
        <div class="text--gray">{{$t('PremiumFeaturesDialog.Description')}}</div>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <a href="mailto:support@getreshub.com" target="_blank">
          <v-btn color="primary" dark>{{$t('PremiumFeaturesDialog.Contact')}}</v-btn>
        </a>
      </v-card-actions>
    </v-card>
   </div>
  </v-container>
</template>

<script>

export default {
  name: 'Premium Features',
  components: {},

  data() {
    return {
      headerImage: require("../../assets/premium-features-header.png"),
    };
  }
};
</script>


<style scoped>
.premium-feature-card {
  max-width: 1000px !important;
  margin: 0 auto !important;
}

.v-main{
   background-color: red !important;
}
</style>